import ReactInputMask from 'react-input-mask';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
  padding: 33px 15px 5px 15px;
  box-shadow: 0 1px 4px 0 rgba(192, 208, 230, 0.8);
  cursor: grab;  
      
  .headerCard {
    position: absolute;
    top: 0;
    min-width: 270px;
    max-width: 300px;
    height: 25px;
    display: flex;
    background-color: rgba(230, 236, 245);
    align-items: center;
    margin-left: -15px;
    padding-left: 15px;

    p {
      margin-left: 5px;
      font-size: 12px;
      font-weight: 500;
      color: #000a;
      line-height: 12px;
    }
  }

  p {
    font-weight: 500;
    line-height: 20px;
    width: 100%; 
    word-wrap: break-word; 
    overflow-wrap: break-word; 
  }

  img {
    width: 35px;
    height: 35px;
    border-radius: 35px;
    margin-top: 5px;
  }

  ${props => props.isDragging && css`
    border: 2px dashed rgba(0, 0, 0, 0.2);
    padding-top: 31px;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    cursor: grabbing;

    p, img, header {
      opacity: 0;
    }
  `}
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${props => props.color};
`;

export const InputTel = styled(ReactInputMask)`
    box-sizing: border-box;
    margin: 0;
    padding: 4px 11px;
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    line-height: 1.5714285714285714;
    list-style: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    background-color: #ffffff;
    background-image: none;
    border-width: 1px;
    border-style: solid;
    border-color: #d9d9d9;
    border-radius: 6px;
    transition: all 0.2s;
    ::placeholder{
      color: #bbb;
      font-size: 13px;
    }
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  max-width: 420px;
  margin-bottom: 5px;
  justify-content: space-between;
  text-align: center;

  p{
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
  }
`;

export const ModalConfirm = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.2);
  align-items: center;
  justify-content: center;
  display: ${props => (props.open ? 'flex' : 'none')};
  transition: 0.5s;
  .content {
    width: 350px;
    background: #fff;
    border-radius: 7px;
    display: flex;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: 15px;
    z-index: 1000;
    display: ${props => (props.open ? 'block' : 'none')};
    transition: 0.5s;
    &-header {
      display: flex;
      margin-bottom: 20px;
      position: relative;
      
      p{
        width: calc(100% - 60px);
        text-align: left;
      }

      .close-button{
        position: absolute;
        top: 0px;
        right: 0px;
        display: flex;
        align-items: center;
        background: transparent;
        justify-content: center;
      }
    }
    &-main {
      padding: 20px 0 40px 0;
      text-align: center;
      > div {
        padding: 5px;
        > span {
          display: block;
        }
      }
    }
    &-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #6a6a6a;
        font-size: 14px;
        cursor: pointer;
      }
      button {
        border: none;
        padding: 10px 15px;
        border-radius: 5px;
        position: relative;
        text-transform: none;
        transition: all 0.15s ease;
        letter-spacing: 0.025em;
        font-size: 0.875rem;
        color: #fff;
        background-color: #f2760a;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
          0 1px 3px rgba(0, 0, 0, 0.08);
      }
    }
  }
`;

